import SVG from "../../../Components/SVG";
import { useState } from "react";

export default function InputPW({
  label = "",
  inputSample = "",
  id = "",
  name = "",
  isReadOnly = true,
  isAuotComplete = false,
  isLTR = false,
  onChange,
  value,
  onBlur,
}) {
  const [showPassword, setShowPassword] = useState(false);

  const handleToggle = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="w-full flex flex-col gap-1">
      <label
        htmlFor={id}
        className="text-sm text-zi-text-light/50 dark:text-zi-text-dark/50"
      >
        {label}
      </label>

      <div
        className={
          "flex items-center justify-between overflow-auto gap-1 " +
          "w-full bg-transparent outline-none rounded-md " +
          "text-zi-text-light dark:text-zi-text-dark border border-zi-border-light dark:border-zi-border-dark " +
          (isReadOnly
            ? "border-opacity-0 dark:border-opacity-0 "
            : "border-opacity-100 dark:border-opacity-100 ") +
          (isReadOnly
            ? " "
            : "hocus:ring-1 hocus-within:ring-zi-border-light hocus-within:dark:ring-zi-border-dark ") +
          (isReadOnly
            ? " "
            : "hocus-within:bg-zi-bg1-light hocus-within:dark:bg-zi-bg1-dark ")
        }
      >
        <input
          defaultValue={inputSample}
          type={showPassword ? "text" : "password"}
          id={id}
          name={name}
          readOnly={isReadOnly}
          autoComplete={isAuotComplete}
          className={
            "w-full text-right bg-transparent outline-none rounded-md p-1 text-base " +
            "text-zi-text-light dark:text-zi-text-dark " +
            (isLTR ? "[direction:ltr]" : "")
          }
          onChange={onChange}
          onBlur={onBlur}
          value={value}
        />
        <button
          type="button"
          tabIndex="-1"
          onClick={handleToggle}
          className={`p-2 ${isReadOnly && "opacity-0"}`}
        >
          <SVG
            name={showPassword ? "eye" : "eyeClosed"}
            classname={
              showPassword
                ? "stroke-zi-blue-dark dark:stroke-white"
                : "fill-zi-blue-dark dark:fill-white"
            }
          />
        </button>

        <style>
          {`
            input[type="password"]::-ms-reveal,
            input[type="password"]::-ms-clear {
              display: none !important;
            }
            input[type="password"]::-webkit-textfield-decoration-container {
              display: none;
            }
            input[type="password"]::-webkit-search-decoration {
              display: none;
            }
          `}
        </style>
      </div>
    </div>
  );
}
